// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__V8p4W","logoText":"Cabecalho_logoText__x9XbF","logoImage":"Cabecalho_logoImage__IUBAG"};